
const DesignColor = {
  mounted() {
    const element = this.el.querySelector('[data-color-hex]')

    const colorRGB = getComputedStyle(this.el.firstElementChild)
      .getPropertyValue('background-color')
      .replace('rgb', '')
      .replace('(', '')
      .replace(')', '')
      .split(', ')
      .map((value) => parseInt(value, 10))

    const colorHEX = `#${((1 << 24) + (colorRGB[0] << 16) + (colorRGB[1] << 8) + colorRGB[2]).toString(16).slice(1)}`;


    if (element) {
      element.innerText = colorHEX
    }
  },
}

export default DesignColor
